module.exports = __webpack_public_path__ + "img/d.37888301.jpg";